import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import {
  type HasPendingDraftsType,
  HasPendingDraftsSchema,
} from '../../../edit-session/schema/EditSessionSchema';
import { InputDataEditSessionUrl } from '../InputDataEditSessionUrl';

const fetchInputDataEditSessionHasDrafts = async (params: {
  sessionId: string;
}) =>
  apiClient
    .get<HasPendingDraftsType>(
      expand(InputDataEditSessionUrl.hasPendingDrafts, params),
    )
    .then((response) => response.data)
    .then(HasPendingDraftsSchema.parse);

export const useInputDataEditSessionHasDraftsQuery = createApiQueryHook(
  ['input-data-edit-session-has-drafts'],
  fetchInputDataEditSessionHasDrafts,
);
